import React, { useEffect, useRef, useState } from 'react'
import { lineRowFromNode } from 'src/helpers/descriptionEditorDom'

interface FocusedLine {
  focusedId: string | null
  focusedIdRef: React.MutableRefObject<string | null>
}

export const useFocusedLine = (rootRef: React.RefObject<HTMLElement | null>): FocusedLine => {
  const focusedIdRef = useRef<string | null>(null)
  const [focusedId, setFocusedId] = useState<string | null>(null)

  useEffect(() => {
    const onSelection = (): void => {
      const root = rootRef.current
      if (root === null) {
        return
      }
      const id = lineRowFromNode(root, window.getSelection()?.anchorNode ?? null)?.dataset.lineId ?? ''
      const next = id === '' ? null : id
      if (focusedIdRef.current === next) {
        return
      }
      focusedIdRef.current = next
      setFocusedId(next)
    }
    document.addEventListener('selectionchange', onSelection)
    return () => {
      document.removeEventListener('selectionchange', onSelection)
    }
  }, [rootRef])

  return { focusedId, focusedIdRef }
}
